import { tenantHttp, type HttpClient } from './core/http-client';
import type { BusinessContextInfo, BusinessProfile, BusinessProfileUpdate } from './models';

export class BusinessService {
  constructor(private readonly http: HttpClient) {}

  context = () => this.http.get<BusinessContextInfo>('/business/context');

  profile = () => this.http.get<BusinessProfile>('/business/profile');

  updateProfile = (b: BusinessProfileUpdate) =>
    this.http.patch<BusinessProfile>('/business/profile', b);

  // Owners only. confirmName is the business name, typed by the owner.
  deleteBusiness = (confirmName: string) =>
    this.http.post<{ deleted: boolean }>('/business/delete', { confirmName });
}

export const businessService = new BusinessService(tenantHttp);
